import React, { useState, useEffect, useRef } from 'react'
import { Editor, Toolbar } from '@wangeditor/editor-for-react'
import {
  DomEditor,
  IEditorConfig,
  IToolbarConfig,
  createEditor,
  IButtonMenu,
  IDomEditor
} from '@wangeditor/editor'
import '@wangeditor/editor/dist/css/style.css' // 引入 css
import { useParams } from 'react-router-dom'
import './css/publish.css'
import general, { redux } from '../../../../../general'
import Dialog from '../../../../../lib/Dialog'
import { BigPlayButton, ControlBar, Player, Shortcut } from 'video-react'
import { useHistory } from 'react-router-dom'
import { NavLink } from '../../../../../lib/Navigation'
import URI from "urijs";
import Compressor from 'compressorjs'
import { useLocalStorageState, useUnmount } from 'ahooks'
import { Switch } from 'antd-mobile'
import { BoxType } from '../../../../../BoxType'

export default function Publish(props) {

  const { topic_id, disable, is_display_activetab } = props.query
  const [mediaType, setMediaType] = useState(0)
  const [videoPath, setVideoPath] = useState()
  const [path, setPath] = useState()
  const [complete, setComplete] = useState(0)
  const [loading, setLoading] = useState(false)
  const [playing, setPlaying] = useState(false)
  const [title, setTitle] = useState('')
  const [titleLength, setTitleLength] = useState(0)
  const titleRef = useRef()
  const videoDom = useRef()
  const histyry = useHistory()
  const draftKey = 'draft-' + topic_id
  const [draft, setDraft] = useLocalStorageState(draftKey)
  const [save, setSave] = useState(true)
  const [item, setItem] = useState()
  const [checked, setChecked] = useState(false)
  const [tagid, setTagid] = useState(1)
  const [cachePublish_from_game, setCachePublish_from_game] = useLocalStorageState('publish_from_game', {})
  const [arr, setArray] = useState([
    { id: 0, name: '发评论', src: `resources/251009/${BoxType}publish-comment.png` },
    { id: 1, name: '发攻略', src: `resources/251009/${BoxType}publish-strategy.png` },
    { id: 2, name: '问大神', src: `resources/251009/${BoxType}publish-ask-god.png` },
  ])
  const [imageIndex, setImageIndex] = useState(0)

  // editor 实例
  const [editor, setEditor] = useState()

  // 编辑器内容
  // const [html, setHtml] = useState('<p>hello</p>')
  const [html, setHtml] = useState()

  // 模拟 ajax 请求，异步设置 html
  useEffect(() => {
    if (props.active) {
      if (draft) {
        setHtml(draft?.content)
        setMediaType(draft?.mediaType)
        setTitleLength(draft?.title.length)
        if (draft?.videoPath) {
          setVideoPath(draft.videoPath)
          setPath(draft.path)
        }
        if (draft?.item) {
          setItem(draft.item)
        }
      }
    }
  }, [props.active, draft])

  // 工具栏配置
  // const toolbar = DomEditor.getToolbar(editor)
  // const curtoolbarConfig = toolbar?.getConfig()
  // console.log('toobal',curtoolbarConfig);

  const contentPlaceholder = () => {
    if (parseInt(tagid) == 1) {
      return '评论配图，评优有奖！晒出你的精彩点评，更容易锁定官方优选席位！'
    } else if (parseInt(tagid) == 2) {
      return '攻略配图，秒变焦点！带图攻略更容易被【官方评优】和玩家赞赏哦！'
    } else if (parseInt(tagid) == 3) {
      return '对问题补充说明或附图，可以更快获得解答~'
    } else if (parseInt(tagid) == 4) {
      return '请输入活动内容...'
    } else {
      return '记录生活，分享美好瞬间...'
    }
  }

  useEffect(() => {
    const placeholder = document.querySelector('.w-e-text-placeholder')
    if (placeholder) {
      placeholder.innerHTML = contentPlaceholder()
    }
  }, [tagid, item?.circles_type]);

  const [isFocus, setIsFocus] = useState(false);
  const handleInputFocus = () => {
    setIsFocus(true);
    setTimeout(() => {
      const html = document.documentElement
      html.scrollTo({ top: 0, behavior: 'smooth' });
    }, 100);
    setTimeout(() => {
      const html = document.documentElement
      html.scrollTo({ top: 0, behavior: 'smooth' });
    }, 1200);
  };

  const handleInputBlur = () => {
    setIsFocus(false);
  }

  // 编辑器配置
  const editorConfig = {
    placeholder: contentPlaceholder(),
    MENU_CONF: {},
    onFocus: handleInputFocus,
    onBlur: handleInputBlur
  }

  editorConfig.customAlert = (s, t) => {
    switch (t) {
      case 'success':
        Dialog.info(s)
        break
      case 'info':
        Dialog.info(s)
        break
      case 'warning':
        Dialog.warning(s)
        break
      case 'error':
        Dialog.error(s)
        break
      default:
        Dialog.info(s)
        break
    }
  }

  const toolbarConfig = {}
  toolbarConfig.toolbarKeys = [
    'uploadImage', 'bold', 'italic', 'underline', 'color', 'bgColor'
  ]

  // toolbarConfig.insertKeys = {
  //   index: 1, // 插入的位置，基于当前的 toolbarKeys
  //   keys: ['uploadImagea']
  // }

  // 自定义校验图片
  function customCheckImageFn(src, alt, url) {
    if (!src) {
      return
    }
    if (src.indexOf('http') !== 0) {
      return '图片网址必须以 http/https 开头'
    }
    return true

    // 返回值有三种选择：
    // 1. 返回 true ，说明检查通过，编辑器将正常插入图片
    // 2. 返回一个字符串，说明检查未通过，编辑器会阻止插入。会 alert 出错误信息（即返回的字符串）
    // 3. 返回 undefined（即没有任何返回），说明检查未通过，编辑器会阻止插入。但不会提示任何信息
  }

  // 转换图片链接
  function customParseImageSrc(src) {
    if (src.indexOf('http') !== 0) {
      return `http://${src}`
    }
    return src
  }

  editorConfig.MENU_CONF['lineHeight'] = {
    lineHeightList: ['1']
  }

  editorConfig.hoverbarKeys = {
    'text': {
      // 如有 match 函数，则优先根据 match 判断，而忽略 element type
      match: (editor, n) => {
        // 可参考下文的源码
      },
      menuKeys: [], // 定义你想要的 menu keys
    },
    'image': {
      match: (editor, n) => {
        // 可参考下文的源码
      },
      menuKeys: []
    }
  }

  editorConfig.MENU_CONF['uploadImage'] = {
    server: 'http://api3.app.99maiyou.com/base/community/image',
    // form-data fieldName ，默认值 'wangeditor-uploaded-image'
    fieldName: 'img',

    // 单个文件的最大体积限制，默认为 2M
    maxFileSize: 10 * 1024 * 1024, // 1M

    // 最多可上传几个文件，默认为 100
    maxNumberOfFiles: 3,

    // 选择文件时的类型限制，默认为 ['image/*'] 。如不想限制，则设置为 []
    allowedFileTypes: ['image/*'],

    // 自定义上传参数，例如传递验证的 token 等。参数会被添加到 formData 中，一起上传到服务端。
    meta: {
      type: 'community'
    },

    // 将 meta 拼接到 url 参数中，默认 false
    metaWithUrl: false,

    // 自定义增加 http  header
    // headers: {
    //     Accept: 'text/x-json',
    //     otherKey: 'xxx'
    // },

    // 跨域是否传递 cookie ，默认为 false
    withCredentials: true,

    // 超时时间，默认为 10 秒
    timeout: 5 * 1000, // 5 秒

    // 上传之前触发
    // onBeforeUpload(file: File) { // TS 语法
    onBeforeUpload(file) {    // JS 语法
      console.log('onBeforeUpload', onBeforeUpload);

      // file 选中的文件，格式如 { key: file }
      return file

      // 可以 return
      // 1. return file 或者 new 一个 file ，接下来将上传
      // 2. return false ，不上传这个 file
    },

    // 上传进度的回调函数
    onProgress(progress) {  // TS 语法
      // onProgress(progress) {       // JS 语法
      // progress 是 0-100 的数字
      console.log('progress', progress)
    },

    // 单个文件上传成功之后
    onSuccess(file, res) {  // TS 语法
      // onSuccess(file, res) {          // JS 语法
      console.log(`${file.name} 上传成功`, res)
    },

    // 单个文件上传失败
    onFailed(file, res) {   // TS 语法
      // onFailed(file, res) {           // JS 语法
      console.log(`${file.name} 上传失败`, res)
    },

    // 上传错误，或者触发 timeout 超时
    onError(file, err, res) {  // TS 语法
      // onError(file, err, res) {               // JS 语法
      console.log(`${file.name} 上传出错`, err, res)
    },

    // customInsert(res: any, insertFn: InsertFnType) {  // TS 语法
    // // customInsert(res, insertFn) {                  // JS 语法
    //     // res 即服务端的返回结果
    //     // 从 res 中找到 url alt href ，然后插入图片
    //     insertFn(res.data.path, 'alt', 'href')
    // },

    async customUpload(file, insertFn) {  // TS 语法
      // async customUpload(file, insertFn) {                   // JS 语法
      const options = {
        maxWidth: 3072,
        checkOrientation: false,
        mimeType: ['image/png', 'image/jpeg'],
        quality: 0.7,
        success: result => {
          const newFile = new File([result], result.name, { type: result.type })
          const formData = new FormData()
          formData.append('img', newFile)
          formData.append('type', 'community')
          general.axios.post('/base/community/image', formData)
            .then(res => {
              const { status, data } = res.data
              if (status.succeed) {
                insertFn(data.path, "alt", "href")
              } else {
                Dialog.error(status.error_desc)
              }
            })
        }
      };

      new Compressor(file, options)
    }

  }

  // 插入图片
  editorConfig.MENU_CONF['insertImage'] = {
    onInsertedImage(imageNode) {
      if (imageNode == null) return

      const { src, alt, url, href } = imageNode
      console.log('inserted image', src, alt, url, href)
      setImageIndex(e=>e+1)
    },
    checkImage: customCheckImageFn, // 也支持 async 函数
    parseImageSrc: customParseImageSrc, // 也支持 async 函数
  }
  // // 编辑图片
  // editorConfig.MENU_CONF['editImage'] = {
  //   onUpdatedImage(imageNode: ImageElement | null) {  // TS 语法
  //   // onUpdatedImage(imageNode) {                    // JS 语法
  //       if (imageNode == null) return

  //       const { src, alt, url } = imageNode
  //       console.log('updated image', src, alt, url)
  //   },
  //   checkImage: customCheckImageFn, // 也支持 async 函数
  //   parseImageSrc: customParseImageSrc, // 也支持 async 函数
  // }
  useEffect(() => {
    if (imageIndex > 0 && editor) {
      setTimeout(() => {
        editor.insertBreak()
      }, 100);
    }
  }, [imageIndex,editor]);
  // 及时销毁 editor ，重要！
  useEffect(() => {
    return () => {
      if (editor == null) return
      editor.destroy()
      setEditor(null)
    }
  }, [editor])

  useUnmount(() => {
    if (save && (title.length > 0 || html !== '<p><br></p>')) {
      const tmp = {
        mediaType,
        tagid,
        title,
        content: html,
        topic_id,
        video: mediaType === 1 && path ? path : '',
        videoPath: mediaType === 1 && videoPath ? videoPath : '',
        item: item,
      }
      console.log(tmp);
      setDraft(tmp)
      Dialog.info('已保存到草稿箱')
    }
  })

  const fileChange = (e) => {
    if (e.target.files.length == 0) {
      return
    }
    const file = e.target.files[0]
    if (!file.size) {
      return
    }
    setComplete(0)
    const formData = new FormData()
    formData.append('video', file)
    formData.append('type', 'community')
    general.axios.post('/base/community/video', formData, {
      onUploadProgress: (progressEvent) => {
        if (progressEvent.lengthComputable) {
          let complete = Math.round((progressEvent.loaded / progressEvent.total) * 10000) / 100.0;
          setComplete(complete)
        }
      }
    })
      .then(res => {
        const { status, data } = res.data
        if (status.succeed) {
          setVideoPath(data.reveal_path)
          setPath(data.path)
        } else {
          Dialog.error(status.error_desc)
        }
      })

  }

  const publishAction = () => {
    if (editor.isEmpty()) {
      Dialog.info('请输入内容')
      return
    }
    const editorText = editor.getText()
    const editImages = editor.getElemsByType('image')
    if (editorText.replace(/\s+/g, '').length == 0 && editImages.length == 0) {
      Dialog.info('请输入内容')
      return
    }
    if (!item) {
      Dialog.info('请先选择要发布的论坛')
      return
    }
    if (complete > 0 && !videoPath) {
      Dialog.info('视频上传中，请稍等...')
      return
    }
    if (complete >= 100 && !videoPath) {
      Dialog.info('视频解析中，请稍等...')
      return
    }
    if (loading) {
      return
    }
    setLoading(true)
    Dialog.loading()
    const tmp = {
      tagid,
      title: titleRef.current.value || '',
      content: html,
      topic_id,
      video: path,
      circles_type: item.circles_type,
      topic_id: item.maiyou_gameid,
      is_synchron_cluster: checked ? 1 : 0,
    }
    general.axios.post('/communityAdd', tmp)
      .finally(() => {
        setLoading(false)
        Dialog.close()
      })
      .then(res => {
        const { status, data } = res.data
        if (status.succeed) {
          setSave(false)
          setDraft()
          localStorage.setItem('cache_community_publish_topicid', item.maiyou_gameid)
          Dialog.success('发布成功', () => {
            histyry.goBack()
          })
        } else {
          Dialog.error(status.error_desc)
        }
      })
  }
  useEffect(() => {
    if (props.active && cachePublish_from_game) {
      console.log(cachePublish_from_game, props)
      setItem(cachePublish_from_game)
      setTagid(props.query?.tagid ? parseInt(props.query.tagid) : 1)
      if (cachePublish_from_game.is_display_activetab == true) {
        setArray(prevArray => [...prevArray, { id: 3, name: '发活动' }])
      }
      setTimeout(() => {
        setCachePublish_from_game(null)
      }, 100);
    }
  }, [props.active, cachePublish_from_game]);

  useEffect(() => {
    redux.subscribe(() => {
      const state = redux.getState()
      if (state.community_selectgame) {
        const game = state.community_selectgame
        setItem(state.community_selectgame)
        if (game.circles_type == 'game') {
          if (game.played == false) {
            setTagid(1)
          }
          if (props.query?.tagid && parseInt(props.query.tagid) == 0) {
            setTagid(1)
          }
        }else{
          setTagid(0)
        }
      }
    })
  }, [])

  useEffect(() => {
    if (props.active) {
      props.setTitle(
        <div className="action">
          <span
            onClick={() => setMediaType(0)}
            className={"text " + (mediaType === 1 ? 'active' : '')}>
            {mediaType === 1 && <img src={`resources/251009/${BoxType}publish-change.png`} height={10} />} 发图文</span>
          <span
            onClick={() => setMediaType(1)}
            className={"text " + (mediaType === 0 ? 'active' : '')}>
            {mediaType === 0 && <img src={`resources/251009/${BoxType}publish-change.png`} height={10} />} 发视频</span>
        </div>
      )
      props.setOperate(<div className="publish" onClick={publishAction}>发表</div>)
    }
  }, [props.active, mediaType, html, tagid, complete, videoPath, path])

  const handleClickTagid = (index) => {
    if (!item.played && index == 1) {
      Dialog.info('只有玩过该游戏才能发布攻略！')
    } else {
      setTagid(index + 1)
    }
  }

  const titlePlaceholderDiv = () => {
    if (parseInt(tagid) == 1) {
      return '填写标题会有更多点赞哦~（选填）'
    } else if (parseInt(tagid) == 2) {
      return '填写标题会有更多点赞哦~（选填）'
    } else if (parseInt(tagid) == 3) {
      return '请输入问题，并以问号结束~（选填）'
    } else if (parseInt(tagid) == 4) {
      return '填输入标题（选填）'
    } else {
      return '填写标题会有更多点赞哦~（选填）'
    }
  }

  return (
    <div className='publish-index'>
      <div className="container">
        {mediaType === 1 ?
          <div className='video'>
            <div className="upload">
              <img src="resources/community/add.png" alt="" width='26px' />
              <div className='text'>点击上传视频</div>
              <input className="file" type="file" accept="video/*" onChange={fileChange}></input>
              <div className="mask" style={{ display: complete > 0 ? '' : 'none' }}>
                <div className="progress" style={{ display: complete < 100 ? '' : 'none' }}>
                  上传中（{complete}）...
                </div>
                <div className="progress" style={{ display: complete >= 100 && !videoPath ? '' : 'none' }}>
                  解析视频中...
                </div>
              </div>
              <div className="player" style={{ display: videoPath ? '' : 'none' }}>
                <Player ref={videoDom}
                  autoPlay={true}
                  playsInline={true}
                  src={videoPath}
                >
                  <Shortcut></Shortcut>
                  <BigPlayButton position='center'></BigPlayButton>
                  <ControlBar autoHide={true}></ControlBar>
                </Player>
                <div className="change">更换视频</div>
                <input id='input-id' className="change-file" type="file" accept="video/*" onChange={fileChange}></input>
                <div className="delete" onClick={() => {
                  Dialog.confirm({
                    title: '视频已上传成功，是否删除？',
                    yes: () => {
                      setComplete(0)
                      setVideoPath()
                      document.getElementById('input-id').value = ''
                    }
                  });
                }}>
                  <img src="resources/community/delete.png" alt="" />
                </div>
              </div>
            </div>
            <NavLink to={(() => {
              let url = URI('https://api3.app.99maiyou.com/criteriaAudit')
                // .addQuery('title', '奖励规则')
                // .addQuery('channel', agent)
                // .addQuery('device_type', (mobileDetect.os() == 'iOS'?10:20))
                .toString();
              return url;
            })()}
              iframe={{ title: '审核准则' }}
              user={false}
            >
              <div className="rule">
                <img src="resources/community/vodeo_rule.png" alt="" />&nbsp;
                <span>视频审核准则</span>
              </div>
            </NavLink>
          </div> : null}
        <div className="title">
          <input ref={titleRef} defaultValue={draft?.title} value={title} type="text" onChange={(e) => {
            if (e.target.value.length > 25) {
              setTitle(title)
              setTitleLength(title.length)
            } else {
              setTitle(e.target.value)
              setTitleLength(e.target.value.length)
            }
          }} placeholder={titlePlaceholderDiv()} />
          <span className='length'>{'(' + titleLength + '/25)'}</span>
        </div>
        <div className="content">
          <Toolbar
            editor={editor}
            defaultConfig={toolbarConfig}
            mode="default"
            style={{ borderBottom: '0.5px solid #D7D2D2' }}
          />
          <Editor
            contenteditable={true}
            defaultConfig={editorConfig}
            value={html}
            onCreated={setEditor}
            onChange={editor => {
              setDraft()
              setHtml(editor.getHtml())
            }}
            mode="default"
            style={{
              height: isFocus ? '30vh' : (tagid == 2 ? 'calc(100vh - 290px - env(safe-area-inset-top) - env(safe-area-inset-bottom))' : 'calc(100vh - 235px - env(safe-area-inset-top) - env(safe-area-inset-bottom))'),
              overflowY: 'scroll'
            }}
          />
        </div>
        <div style={{ position: 'fixed', bottom: '0px', left: '0px', right: '0px', paddingBottom: 'env(safe-area-inset-bottom)', maxWidth: '720px', margin: '0 auto' }}>
          <div style={{ padding: '15px', borderTop: '0.5px solid #D7D2D2' }}>
            <NavLink to={disable ? '' : '/selectgame'} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', }}>
              <div>发布至论坛</div>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                {item && <img src={item.bgicon} alt='' height={14} />}
                <div style={{ fontSize: '13px', color: '#282828', paddingRight: '3px', paddingLeft: '5px' }}>{item ? item.game_name : '请选择'}</div>
                {!disable && <img onClick={e => {
                  e.preventDefault();
                  e.stopPropagation();
                  setItem()
                  setTagid(1)
                }} src={`resources/251009/` + (item ? 'game-delete' : 'publish-more') + '.png'} alt="" height={8} />}
              </div>
            </NavLink>
            {item && item.circles_type == 'game' && <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', padding: '15px 0 0', overflow: 'scroll' }}>
              {arr.map((it, id) => {
                return <div key={id} style={{
                  display: 'flex',
                  alignItems: 'center',
                  padding: '5px 14px',
                  border: (tagid === it.id + 1 ? '0.5px solid var(--MainColor)' : '0.5px solid #666'),
                  borderRadius: '16px',
                  color: (tagid === it.id + 1 ? 'var(--MainColor)' : '#282828'),
                  fontSize: '13px',
                  marginRight: '15px',
                  flexShrink: 0
                }} onClick={() => handleClickTagid(id)}>
                  <img src={it.src} alt="" height={14} />
                  <span style={{ paddingLeft: '5px' }}>{it.name}</span>
                </div>
              })}
            </div>}
          </div>
          {tagid == 2 && item.is_open_cluster == true && <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '15px', borderTop: '0.5px solid #D7D2D2' }}>
            <div>同步至群聊</div>
            <Switch
              defaultChecked={true}
              checked={checked}
              style={{ '--checked-color': '#4cd964', '--height': '18px', '--width': '30px' }}
              onChange={async val => {
                setChecked(val)
              }}
            />
          </div>}
        </div>
      </div>
    </div>
  )
}